<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import VuePageCommands from "@Evaluation/EvaluationModels/Domain/commands-vue-component";
    import { Refresh } from '@browser/Browser';
    import { IEvaluationCommand } from '@Evaluation/cqrs';
    import { ICommandStatus } from '@cqrs/cqrs';


    @Component
    export default class VotesGeneratorPage extends mixins(VuePageCommands)
    {
        AccessUrl: string = null;
        GenerateVotesForAllRespondents: boolean = false;
        isProcessing: boolean = false;

        GenerateVotesCommand()
        {
            if (!this.AccessUrl) return;

            this.invokeGenerateVotesCommandV1(this.AccessUrl, this.GenerateVotesForAllRespondents);

            this.isProcessing = true;
        }

        mounted()
        {
            document.title = "Votes generator | TransparentChoice";
        }

        onCommandSucceed(cmd: IEvaluationCommand, correlationId: string)
        {
            Refresh();
        }
        onCommandFailed(status: ICommandStatus)
        {
            Refresh();
        }
    }

</script>

<template>
    <div>
        <div v-if="isProcessing === true">
            Generating...
        </div>

        <div v-if="isProcessing === false" class="container">
            <br /><br />
            <br />
            <p class="mb-0">Respondent's access url:</p>
            <p><input type="text" class="form-control" v-model.trim="AccessUrl" /></p>
            <p><input type="checkbox" v-model="GenerateVotesForAllRespondents" /> Generate votes for all individual respondents in that survey</p>
            <p><button @click="GenerateVotesCommand" :disabled="!AccessUrl" type="button" class="btn btn-primary">Generate</button></p>
        </div>
    </div>
</template>
